export default [
  {
    isoCode: 'af',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '93',
  },
  {
    isoCode: 'za',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '27',
  },
  {
    isoCode: 'al',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
      '(###) XXX-X##',
      '(##X) XXX-XXX',
    ],
    ddi: '355',
  },
  {
    isoCode: 'de',
    mask: [
      '###-###',
      '##X-XXX',
      '(###) ##-##',
      '(##X) XX-XX',
      '(###) ##-###',
      '(##X) XX-XX#',
      '(###) ##-####',
      '(##X) XX-XX##',
      '(###) ###-####',
      '(##X) XXX-X###',
      '(####) ###-####',
      '(##XX) XXX-####',
    ],
    ddi: '49',
  },
  {
    isoCode: 'ad',
    mask: [
      '###-###',
      '##X-XXX',
    ],
    ddi: '376',
  },
  {
    isoCode: 'ao',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '244',
  },
  {
    isoCode: 'ag',
    mask: [
      '(268) ###-####',
      '(268) ##X-XXXX',
    ],
    ddi: '1-268',
  },
  {
    isoCode: 'ar',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '54',
  },
  {
    isoCode: 'am',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '374',
  },
  {
    isoCode: 'sa',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
      '5#-####-####',
      '5#-#XXX-XX##',
    ],
    ddi: '966',
  },
  {
    isoCode: 'au',
    mask: [
      '#-####-####',
      '#-#XXX-XX##',
    ],
    ddi: '61',
  },
  {
    isoCode: 'at',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '43',
  },
  {
    isoCode: 'az',
    mask: [
      '##-###-##-##',
      '##-XXX-XX-##',
    ],
    ddi: '994',
  },
  {
    isoCode: 'bs',
    mask: [
      '(242) ###-####',
      '(242) ##X-XXXX',
    ],
    ddi: '1-242',
  },
  {
    isoCode: 'bh',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '973',
  },
  {
    isoCode: 'bd',
    mask: [
      '1###-######',
      '1##X-XXXX##',
    ],
    ddi: '880',
  },
  {
    isoCode: 'bb',
    mask: [
      '(246) ###-####',
      '(246) ##X-XXXX',
    ],
    ddi: '1-246',
  },
  {
    isoCode: 'bz',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '501',
  },
  {
    isoCode: 'bj',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '229',
  },
  {
    isoCode: 'by',
    mask: [
      '(##) ###-##-##',
      '(##) XXX-XX-##',
    ],
    ddi: '375',
  },
  {
    isoCode: 'bo',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
    ],
    ddi: '591',
  },
  {
    isoCode: 'bw',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '267',
  },
  {
    isoCode: 'br',
    mask: [
      '(##) ####-####',
      '(##) XXXX-X###',
      '(##) #####-####',
      '(##) XXXXX-####',
    ],
    ddi: '55',
  },
  {
    isoCode: 'bn',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '673',
  },
  {
    isoCode: 'bg',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '359',
  },
  {
    isoCode: 'bf',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '226',
  },
  {
    isoCode: 'bi',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '257',
  },
  {
    isoCode: 'bt',
    mask: [
      '17-###-###',
      '17-##X-XXX',
      '77-###-###',
      '77-##X-XXX',
      '#-###-###',
      '#-#XX-XXX',
    ],
    ddi: '975',
  },
  {
    isoCode: 'be',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '32',
  },
  {
    isoCode: 'ba',
    mask: [
      '##-####',
      '##-XXXX',
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '387',
  },
  {
    isoCode: 'cv',
    mask: [
      '(###) ##-##',
      '(##X) XX-XX',
    ],
    ddi: '238',
  },
  {
    isoCode: 'cm',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '237',
  },
  {
    isoCode: 'kh',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '855',
  },
  {
    isoCode: 'ca',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '1',
  },
  {
    isoCode: 'qa',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '974',
  },
  {
    isoCode: 'kz',
    mask: [
      '(6##) ###-##-##',
      '(6##) XXX-XX-##',
      '(7##) ###-##-##',
      '(7##) XXX-XX-##',
    ],
    ddi: '7',
  },
  {
    isoCode: 'td',
    mask: [
      '##-##-##-##',
      '##-XX-XX-X#',
    ],
    ddi: '235',
  },
  {
    isoCode: 'cl',
    mask: [
      '#-####-####',
      '#-#XXX-XX##',
    ],
    ddi: '56',
  },
  {
    isoCode: 'cn',
    mask: [
      '(###) ####-###',
      '(##X) XXXX-###',
      '(###) ####-####',
      '(##X) XXXX-####',
      '##-#####-#####',
      '##-XXXXX-#####',
    ],
    ddi: '86',
  },
  {
    isoCode: 'cy',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '357',
  },
  {
    isoCode: 'sg',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '65',
  },
  {
    isoCode: 'co',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '57',
  },
  {
    isoCode: 'km',
    mask: [
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '269',
  },
  {
    isoCode: 'cd',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '243',
  },
  {
    isoCode: 'cg',
    mask: [
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '242',
  },
  {
    isoCode: 'kp',
    mask: [
      '###-###',
      '##X-XXX',
      '####-####',
      '##XX-XXX#',
      '##-###-###',
      '##-XXX-XX#',
      '###-####-###',
      '##X-XXXX-###',
      '191-###-####',
      '191-##X-XXXX',
      '####-#############',
      '##XX-XXX##########',
    ],
    ddi: '850',
  },
  {
    isoCode: 'kr',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '82',
  },
  {
    isoCode: 'cr',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '506',
  },
  {
    isoCode: 'hr',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '385',
  },
  {
    isoCode: 'cu',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
    ],
    ddi: '53',
  },
  {
    isoCode: 'dk',
    mask: [
      '##-##-##-##',
      '##-XX-XX-X#',
    ],
    ddi: '45',
  },
  {
    isoCode: 'dj',
    mask: [
      '##-##-##-##',
      '##-XX-XX-X#',
    ],
    ddi: '253',
  },
  {
    isoCode: 'dm',
    mask: [
      '(767) ###-####',
      '(767) ##X-XXXX',
    ],
    ddi: '1-767',
  },
  {
    isoCode: 'eg',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '20',
  },
  {
    isoCode: 'sv',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '503',
  },
  {
    isoCode: 'ae',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
      '5#-###-####',
      '5#-#XX-XXX#',
    ],
    ddi: '971',
  },
  {
    isoCode: 'ec',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '593',
  },
  {
    isoCode: 'er',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
    ],
    ddi: '291',
  },
  {
    isoCode: 'sk',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '421',
  },
  {
    isoCode: 'si',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '386',
  },
  {
    isoCode: 'es',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '34',
  },
  {
    isoCode: 'us',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '1',
  },
  {
    isoCode: 'ee',
    mask: [
      '###-####',
      '##X-XXXX',
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '372',
  },
  {
    isoCode: 'sz',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '268',
  },
  {
    isoCode: 'et',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '251',
  },
  {
    isoCode: 'fj',
    mask: [
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '679',
  },
  {
    isoCode: 'ph',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '63',
  },
  {
    isoCode: 'fi',
    mask: [
      '(###) ###-##-##',
      '(##X) XXX-X#-##',
    ],
    ddi: '358',
  },
  {
    isoCode: 'fr',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '33',
  },
  {
    isoCode: 'ga',
    mask: [
      '#-##-##-##',
      '#-#X-XX-XX',
    ],
    ddi: '241',
  },
  {
    isoCode: 'gh',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '233',
  },
  {
    isoCode: 'ge',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '995',
  },
  {
    isoCode: 'gd',
    mask: [
      '(473) ###-####',
      '(473) ##X-XXXX',
    ],
    ddi: '1-473',
  },
  {
    isoCode: 'gr',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '30',
  },
  {
    isoCode: 'gt',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
    ],
    ddi: '502',
  },
  {
    isoCode: 'gy',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '592',
  },
  {
    isoCode: 'gn',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '224',
  },
  {
    isoCode: 'gq',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '240',
  },
  {
    isoCode: 'gw',
    mask: [
      '#-######',
      '#-#XXXXX',
    ],
    ddi: '245',
  },
  {
    isoCode: 'gm',
    mask: [
      '(###) ##-##',
      '(##X) XX-XX',
    ],
    ddi: '220',
  },
  {
    isoCode: 'ht',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '509',
  },
  {
    isoCode: 'hn',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '504',
  },
  {
    isoCode: 'hu',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '36',
  },
  {
    isoCode: 'mh',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '692',
  },
  {
    isoCode: 'sb',
    mask: [
      '#####',
      '##XXX',
      '###-####',
      '##X-XXXX',
    ],
    ddi: '677',
  },
  {
    isoCode: 'id',
    mask: [
      '##-###-##',
      '##-XXX-XX',
      '##-###-###',
      '##-XXX-XX#',
      '##-###-####',
      '##-XXX-XX##',
      '(8##) ###-###',
      '(8##) XXX-XX#',
      '(8##) ###-##-###',
      '(8##) XXX-XX-###',
    ],
    ddi: '62',
  },
  {
    isoCode: 'iq',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '964',
  },
  {
    isoCode: 'ie',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '353',
  },
  {
    isoCode: 'ir',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '98',
  },
  {
    isoCode: 'is',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '354',
  },
  {
    isoCode: 'il',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
      '5#-###-####',
      '5#-#XX-XXX#',
    ],
    ddi: '972',
  },
  {
    isoCode: 'it',
    mask: [
      '(###) ####-###',
      '(##X) XXXX-###',
    ],
    ddi: '39',
  },
  {
    isoCode: 'ye',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
      '##-###-###',
      '##-XXX-XX#',
      '###-###-###',
      '##X-XXX-X##',
    ],
    ddi: '967',
  },
  {
    isoCode: 'in',
    mask: [
      '(####) ###-###',
      '(##XX) XXX-###',
    ],
    ddi: '91',
  },
  {
    isoCode: 'jm',
    mask: [
      '(876) ###-####',
      '(876) ##X-XXXX',
    ],
    ddi: '1-876',
  },
  {
    isoCode: 'jp',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
      '##-####-####',
      '##-XXXX-X###',
    ],
    ddi: '81',
  },
  {
    isoCode: 'jo',
    mask: [
      '#-####-####',
      '#-#XXX-XX##',
    ],
    ddi: '962',
  },
  {
    isoCode: 'ki',
    mask: [
      '##-###',
      '##-XXX',
    ],
    ddi: '686',
  },
  {
    isoCode: 'kw',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '965',
  },
  {
    isoCode: 'la',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
      '(20##) ###-###',
      '(20##) XXX-XX#',
    ],
    ddi: '856',
  },
  {
    isoCode: 'ls',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
    ],
    ddi: '266',
  },
  {
    isoCode: 'lv',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '371',
  },
  {
    isoCode: 'lr',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '231',
  },
  {
    isoCode: 'li',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '423',
  },
  {
    isoCode: 'lt',
    mask: [
      '(###) ##-###',
      '(##X) XX-XX#',
    ],
    ddi: '370',
  },
  {
    isoCode: 'lu',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '352',
  },
  {
    isoCode: 'lb',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '961',
  },
  {
    isoCode: 'ly',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
      '21-###-####',
      '21-##X-XXXX',
    ],
    ddi: '218',
  },
  {
    isoCode: 'mk',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '389',
  },
  {
    isoCode: 'mg',
    mask: [
      '##-##-#####',
      '##-XX-XXX##',
    ],
    ddi: '261',
  },
  {
    isoCode: 'mw',
    mask: [
      '1-###-###',
      '1-##X-XXX',
      '#-####-####',
      '#-#XXX-XX##',
    ],
    ddi: '265',
  },
  {
    isoCode: 'mv',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '960',
  },
  {
    isoCode: 'ml',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '223',
  },
  {
    isoCode: 'mt',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '356',
  },
  {
    isoCode: 'my',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
      '##-###-###',
      '##-XXX-XX#',
      '(###) ###-###',
      '(##X) XXX-X##',
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '60',
  },
  {
    isoCode: 'ma',
    mask: [
      '##-####-###',
      '##-XXXX-X##',
    ],
    ddi: '212',
  },
  {
    isoCode: 'mr',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '222',
  },
  {
    isoCode: 'mu',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '230',
  },
  {
    isoCode: 'mm',
    mask: [
      '###-###',
      '##X-XXX',
      '#-###-###',
      '#-#XX-XXX',
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '95',
  },
  {
    isoCode: 'fm',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '691',
  },
  {
    isoCode: 'md',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '373',
  },
  {
    isoCode: 'mn',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '976',
  },
  {
    isoCode: 'me',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '382',
  },
  {
    isoCode: 'mz',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '258',
  },
  {
    isoCode: 'mx',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '52',
  },
  {
    isoCode: 'mc',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '377',
  },
  {
    isoCode: 'na',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '264',
  },
  {
    isoCode: 'nr',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '674',
  },
  {
    isoCode: 'np',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '977',
  },
  {
    isoCode: 'ni',
    mask: [
      '####-####',
      '##XX-XXX#',
    ],
    ddi: '505',
  },
  {
    isoCode: 'ng',
    mask: [
      '##-###-##',
      '##-XXX-XX',
      '##-###-###',
      '##-XXX-XX#',
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '234',
  },
  {
    isoCode: 'no',
    mask: [
      '(###) ##-###',
      '(##X) XX-XX#',
    ],
    ddi: '47',
  },
  {
    isoCode: 'nz',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
      '(###) ###-###',
      '(##X) XXX-X##',
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '64',
  },
  {
    isoCode: 'ne',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '227',
  },
  {
    isoCode: 'om',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '968',
  },
  {
    isoCode: 'pw',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '680',
  },
  {
    isoCode: 'ps',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '970',
  },
  {
    isoCode: 'pa',
    mask: [
      '###-####',
      '##X-XXXX',
    ],
    ddi: '507',
  },
  {
    isoCode: 'pg',
    mask: [
      '(###) ##-###',
      '(##X) XX-XX#',
    ],
    ddi: '675',
  },
  {
    isoCode: 'pk',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '92',
  },
  {
    isoCode: 'py',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '595',
  },
  {
    isoCode: 'nl',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '31',
  },
  {
    isoCode: 'pe',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '51',
  },
  {
    isoCode: 'pl',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '48',
  },
  {
    isoCode: 'pt',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '351',
  },
  {
    isoCode: 'kg',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '996',
  },
  {
    isoCode: 'ke',
    mask: [
      '###-######',
      '##X-XXXX##',
    ],
    ddi: '254',
  },
  {
    isoCode: 'gb',
    mask: [
      '##-####-####',
      '##-XXXX-X###',
    ],
    ddi: '44',
  },
  {
    isoCode: 'cf',
    mask: [
      '##-##-####',
      '##-XX-XXX#',
    ],
    ddi: '236',
  },
  {
    isoCode: 'do',
    mask: [
      '(809) ###-####',
      '(809) ##X-XXXX',
      '(829) ###-####',
      '(829) ##X-XXXX',
      '(849) ###-####',
      '(849) ##X-XXXX',
    ],
    ddi: '1-809',
  },
  {
    isoCode: 'cz',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '420',
  },
  {
    isoCode: 'ro',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '40',
  },
  {
    isoCode: 'rw',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '250',
  },
  {
    isoCode: 'ru',
    mask: [
      '(###) ###-##-##',
      '(##X) XXX-X#-##',
    ],
    ddi: '7',
  },
  {
    isoCode: 'ws',
    mask: [
      '##-####',
      '##-XXXX',
    ],
    ddi: '685',
  },
  {
    isoCode: 'sm',
    mask: [
      '####-######',
      '##XX-XXX###',
    ],
    ddi: '378',
  },
  {
    isoCode: 'lc',
    mask: [
      '(758) ###-####',
      '(758) ##X-XXXX',
    ],
    ddi: '1-758',
  },
  {
    isoCode: 'sc',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
    ],
    ddi: '248',
  },
  {
    isoCode: 'sn',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '221',
  },
  {
    isoCode: 'sl',
    mask: [
      '##-######',
      '##-XXXXX#',
    ],
    ddi: '232',
  },
  {
    isoCode: 'so',
    mask: [
      '#-###-###',
      '#-#XX-XXX',
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '252',
  },
  {
    isoCode: 'lk',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '94',
  },
  {
    isoCode: 'sd',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '249',
  },
  {
    isoCode: 'ss',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '211',
  },
  {
    isoCode: 'sr',
    mask: [
      '###-###',
      '##X-XXX',
      '###-####',
      '##X-XXXX',
    ],
    ddi: '597',
  },
  {
    isoCode: 'se',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '46',
  },
  {
    isoCode: 'ch',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '41',
  },
  {
    isoCode: 'kn',
    mask: [
      '(869) ###-####',
      '(869) ##X-XXXX',
    ],
    ddi: '1-869',
  },
  {
    isoCode: 'st',
    mask: [
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '239',
  },
  {
    isoCode: 'vc',
    mask: [
      '(784) ###-####',
      '(784) ##X-XXXX',
    ],
    ddi: '1-784',
  },
  {
    isoCode: 'rs',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '381',
  },
  {
    isoCode: 'sy',
    mask: [
      '##-####-###',
      '##-XXXX-X##',
    ],
    ddi: '963',
  },
  {
    isoCode: 'th',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '66',
  },
  {
    isoCode: 'tw',
    mask: [
      '####-####',
      '##XX-XXX#',
      '#-####-####',
      '#-#XXX-XX##',
    ],
    ddi: '886',
  },
  {
    isoCode: 'tj',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '992',
  },
  {
    isoCode: 'tz',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '255',
  },
  {
    isoCode: 'tg',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '228',
  },
  {
    isoCode: 'to',
    mask: [
      '#####',
      '##XXX',
    ],
    ddi: '676',
  },
  {
    isoCode: 'tt',
    mask: [
      '(868) ###-####',
      '(868) ##X-XXXX',
    ],
    ddi: '1-868',
  },
  {
    isoCode: 'tn',
    mask: [
      '##-###-###',
      '##-XXX-XX#',
    ],
    ddi: '216',
  },
  {
    isoCode: 'tm',
    mask: [
      '#-###-####',
      '#-#XX-XXX#',
    ],
    ddi: '993',
  },
  {
    isoCode: 'tr',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '90',
  },
  {
    isoCode: 'tv',
    mask: [
      '2####',
      '2##XX',
      '90####',
      '90##XX',
    ],
    ddi: '688',
  },
  {
    isoCode: 'ua',
    mask: [
      '(##) ###-##-##',
      '(##) XXX-XX-##',
    ],
    ddi: '380',
  },
  {
    isoCode: 'ug',
    mask: [
      '(###) ###-###',
      '(##X) XXX-X##',
    ],
    ddi: '256',
  },
  {
    isoCode: 'uy',
    mask: [
      '#-###-##-##',
      '#-#XX-XX-X#',
    ],
    ddi: '598',
  },
  {
    isoCode: 'uz',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '998',
  },
  {
    isoCode: 'vu',
    mask: [
      '#####',
      '##XXX',
      '##-#####',
      '##-XXXXX',
    ],
    ddi: '678',
  },
  {
    isoCode: 'va',
    mask: [
      '06 698#####',
      '06 698##XXX',
    ],
    ddi: '39',
  },
  {
    isoCode: 've',
    mask: [
      '(###) ###-####',
      '(##X) XXX-X###',
    ],
    ddi: '58',
  },
  {
    isoCode: 'vn',
    mask: [
      '##-####-###',
      '##-XXXX-X##',
      '(###) ####-###',
      '(##X) XXXX-###',
    ],
    ddi: '84',
  },
  {
    isoCode: 'zw',
    mask: [
      '#-######',
      '#-#XXXXX',
    ],
    ddi: '263',
  },
  {
    isoCode: 'zm',
    mask: [
      '##-###-####',
      '##-XXX-XX##',
    ],
    ddi: '260',
  },
]
